import { SetupApiModel } from '../../../../lib/api/rulemanager/types';

export interface IAppSettings extends SetupApiModel {}

export interface IAppSettingsBase extends IAppSettings {}

export interface ISettingsCache {
  settings: IAppSettingsBase;
}

export const RuleManagerSettingsCache: ISettingsCache = {
  settings: {
    features: [],
    links: {},
    smartSend: { Name: 'Smart Send' }
  }
};
